var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ChevronUp component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconChevronUp extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9995 8.34831L3.38482 16.963C3.09193 17.2559 2.61706 17.2559 2.32416 16.963C2.03127 16.6701 2.03127 16.1952 2.32416 15.9023L10.9699 7.2566C11.1013 7.11936 11.2588 7.00972 11.4332 6.9342C11.612 6.85682 11.8047 6.81689 11.9995 6.81689C12.1943 6.81689 12.387 6.85682 12.5657 6.9342C12.7402 7.00972 12.8977 7.11936 13.0291 7.2566L21.6748 15.9023C21.9677 16.1952 21.9677 16.6701 21.6748 16.963C21.3819 17.2559 20.9071 17.2559 20.6142 16.963L11.9995 8.34831Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconChevronUp.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronUp.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconChevronUp.prototype, "size", void 0);
if (customElements.get('cat-icon-chevron-up') === undefined) {
    customElements.define('cat-icon-chevron-up', BlocksIconChevronUp);
}
